import React, { useState } from "react";
import Blogs from "../../components/ui/cards/Blog.js";
import Doctor from "../../components/ui/cards/Doctor.js";
import FaqService from "../../components/ui/cards/FaqService.js";
import { FaHeartbeat } from "react-icons/fa";
import { FaHeadSideVirus, FaTruckMedical, FaUserDoctor } from "react-icons/fa6";
import { TbDentalBroken } from "react-icons/tb";
import { LiaEye } from "react-icons/lia";
import Cardiology from "../../components/ui/cards/departments/Cardiology.js";
import Neurology from "../../components/ui/cards/departments/Neurology.js";
import Diagnostic from "../../components/ui/cards/departments/Diagnostic.js";
import Dental from "../../components/ui/cards/departments/Dental.js";
import Ophthalmology from "../../components/ui/cards/departments/Ophthalmology.js";
import Emergency from "../../components/ui/cards/departments/Emergency.js";
import Testimonials from "../../components/ui/cards/Testimonials.js";

function Home() {
  const [currentDepartment, setCurrentDepartment] = useState("Cardiology");
  return (
    <>
      {/* First ( Hero ) Section created */}
      <div
        id='home'
        className='bg-fixed bg-hero bg-no-repeat bg-cover relative h-screen w-full'
      >
        <div className='absolute inset-0 customBackgroundHeroSection flex justify-center items-center'>
          <div className='w-[90%] md:w-2/3 lg:w-1/2 text-white'>
            <div className='text-center z-10'>
              <h1 className='text-4xl md:text-6xl'>
                THE MOST VALUABLE THING IS YOUR HEALTH
              </h1>
              <p className='leading-loose text-base md:text-lg pt-5'>
                We care about your health Even the all-powerful Pointing has no
                control about the blind texts it is an almost unorthographic
                life
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48'>
        <div className='sm:flex gap-24 items-center'>
          <div className='w-full sm:w-[35%] transform -translate-y-10 pl-4 pt-16 pb-20 sm:pb-52 bg-primary'>
            <ul>
              <li
                onClick={() => setCurrentDepartment("Cardiology")}
                className='text-white/60 mb-7 hover:font-semibold flex justify-between items-center'
              >
                <div
                  className={`flex items-center gap-5 ${
                    currentDepartment === "Cardiology" &&
                    "text-white font-semibold"
                  }`}
                >
                  <FaHeartbeat size={28} />
                  <h1 className='text-xl'>Cardiology</h1>
                </div>
                <div>
                  {currentDepartment === "Cardiology" && (
                    <div className='w-0 h-0 border-t-[15px] border-t-transparent border-r-[15px] border-white border-b-[15px] border-b-transparent'></div>
                  )}
                </div>
              </li>
              <li
                onClick={() => {
                  setCurrentDepartment("Neurology");
                }}
                className='text-white/60 mb-7 hover:font-semibold flex justify-between items-center'
              >
                <div
                  className={`flex items-center gap-5 ${
                    currentDepartment === "Neurology" &&
                    "text-white font-semibold"
                  }`}
                >
                  <FaHeadSideVirus size={28} />
                  <h1 className='text-xl'>Neurology</h1>
                </div>
                <div>
                  {currentDepartment === "Neurology" && (
                    <div className='w-0 h-0 border-t-[15px] border-t-transparent border-r-[15px] border-white border-b-[15px] border-b-transparent'></div>
                  )}
                </div>
              </li>
              <li
                onClick={() => {
                  setCurrentDepartment("Diagnostic");
                }}
                className='text-white/60 mb-7 hover:font-semibold flex justify-between items-center'
              >
                <div
                  className={`flex items-center gap-5 ${
                    currentDepartment === "Diagnostic" &&
                    "text-white font-semibold"
                  }`}
                >
                  <FaUserDoctor size={28} />
                  <h1 className='text-xl'>Diagnostic</h1>
                </div>
                <div>
                  {currentDepartment === "Diagnostic" && (
                    <div className='w-0 h-0 border-t-[15px] border-t-transparent border-r-[15px] border-white border-b-[15px] border-b-transparent'></div>
                  )}
                </div>
              </li>
              <li
                onClick={() => {
                  setCurrentDepartment("Dental");
                }}
                className='text-white/60 mb-7 hover:font-semibold flex justify-between items-center'
              >
                <div
                  className={`flex items-center gap-5 ${
                    currentDepartment === "Dental" && "text-white font-semibold"
                  }`}
                >
                  <TbDentalBroken size={28} />
                  <h1 className='text-xl'>Dental</h1>
                </div>
                <div>
                  {currentDepartment === "Dental" && (
                    <div className='w-0 h-0 border-t-[15px] border-t-transparent border-r-[15px] border-white border-b-[15px] border-b-transparent'></div>
                  )}
                </div>
              </li>
              <li
                onClick={() => {
                  setCurrentDepartment("Ophthalmology");
                }}
                className='text-white/60 mb-7 hover:font-semibold flex justify-between items-center'
              >
                <div
                  className={`flex items-center gap-5 ${
                    currentDepartment === "Ophthalmology" &&
                    "text-white font-semibold"
                  }`}
                >
                  <LiaEye size={28} />
                  <h1 className='text-xl'>Ophthalmology</h1>
                </div>
                <div>
                  {currentDepartment === "Ophthalmology" && (
                    <div className='w-0 h-0 border-t-[15px] border-t-transparent border-r-[15px] border-white border-b-[15px] border-b-transparent'></div>
                  )}
                </div>
              </li>
              <li
                onClick={() => {
                  setCurrentDepartment("Emergency");
                }}
                className='text-white/60 mb-7 hover:font-semibold flex justify-between items-center'
              >
                <div
                  className={`flex items-center gap-5 ${
                    currentDepartment === "Emergency" &&
                    "text-white font-semibold"
                  }`}
                >
                  <FaTruckMedical size={28} />
                  <h1 className='text-xl'>Emergency</h1>
                </div>
                <div>
                  {currentDepartment === "Emergency" && (
                    <div className='w-0 h-0 border-t-[15px] border-t-transparent border-r-[15px] border-white border-b-[15px] border-b-transparent'></div>
                  )}
                </div>
              </li>
            </ul>
          </div>
          <div className='w-full sm:w-[65%] pb-5'>
            <div>{currentDepartment === "Cardiology" && <Cardiology />}</div>
            <div>{currentDepartment === "Neurology" && <Neurology />}</div>
            <div>{currentDepartment === "Diagnostic" && <Diagnostic />}</div>
            <div>{currentDepartment === "Dental" && <Dental />}</div>
            <div>
              {currentDepartment === "Ophthalmology" && <Ophthalmology />}
            </div>
            <div>{currentDepartment === "Emergency" && <Emergency />}</div>
          </div>
        </div>
      </div>
      <div>
        <div className='bg-faq bg-no-repeat bg-cover h-screen sm:h-[95vh] lg:h-[80.5vh] xl:h-[70.5vh] w-full'>
          <div>
            <div>
              <FaqService
                title='Laboratory Services'
                disc='Even the all-powerful Pointing has no control about the blind.'
              />
              <FaqService
                title='General Treatment'
                disc='Even the all-powerful Pointing has no control about the blind.'
              />
              <FaqService
                title='Emergency Service'
                disc='Even the all-powerful Pointing has no control about the blind.'
              />
              <FaqService
                title='24/7 Help & Support'
                disc='Even the all-powerful Pointing has no control about the blind.'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        {/* OUR EXPERIENCED DOCTORS */}
        <div>
          <h1 className='uppercase text-center mb-20 text-2xl sm:text-3xl text-gray-700'>
            OUR EXPERIENCED DOCTORS
          </h1>
          <div className='flex justify-center items-center'>
            <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-10 sm:gap-14'>
              <Doctor
                title='Dr. John Doe'
                dic='Cardiologist'
                pic={require("../../assets/doctors/1.webp")}
              />
              <Doctor
                title='Aldin Powell'
                dic='Neurologist'
                pic={require("../../assets/doctors/2.webp")}
              />
              <Doctor
                title='Aldin Powell'
                dic='Pediatrician'
                pic={require("../../assets/doctors/3.webp")}
              />
              <Doctor
                title='Aldin Powell'
                dic='Pulmonologist'
                pic={require("../../assets/doctors/4.webp")}
              />
            </div>
          </div>
          <div className='mt-14 w-[95%] sm:w-[80%]'>
            <h1 className='text-2xl mb-2.5 text-black/70'>
              We are well experienced doctors
            </h1>
            <p className='text-gray-500 leading-loose'>
              A small river named Duden flows by their place and supplies it
              with the necessary regelialia. It is a paradisematic country, in
              which roasted parts of sentences fly into your mouth.
            </p>
          </div>
        </div>
      </div>
      {/* SOME FUN FACTS */}
      <div>
        <div className='bg-facts bg-no-repeat bg-cover relative h-screen sm:h-[78vh] w-full'>
          <div className='absolute inset-0 flex justify-center items-center bg-white/10'>
            <div className='text-white text-center'>
              <h1 className='uppercase text-3xl'>SOME FUN FACTS</h1>
              <p className='my-5 sm:my-10 px-5 sm:px-0'>
                Far far away, behind the word mountains, far from the countries
              </p>
              <div className='grid grid-cols-1 sm:grid-cols-4 gap-14 sm:gap-32 lg:gap-40 xl:gap-44 mt-8 sm:mt-14'>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>60</h1>
                  <p className='text-sm text-white/90 mt-4'>Hospital</p>
                </div>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>200</h1>
                  <p className='text-sm text-white/90 mt-4'>Doctors</p>
                </div>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>100</h1>
                  <p className='text-sm text-white/90 mt-4'>Clinics</p>
                </div>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>200</h1>
                  <p className='text-sm text-white/90 mt-4'>Reviews</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 pt-28'>
        <h1 className='uppercase text-center mb-20 text-2xl sm:text-3xl text-gray-700'>
          TESTIMONIALS
        </h1>
        <div className='flex justify-center'>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 items-center gap-20'>
            <Testimonials
              pic={require("../../assets/testimonials/1.webp")}
              name='Dennis Green'
              dic='Patient'
            />
            <Testimonials
              pic={require("../../assets/testimonials/3.webp")}
              name='Dennis Green'
              dic='Doctor'
            />
            <Testimonials
              pic={require("../../assets/testimonials/2.webp")}
              name='Dennis Green'
              dic='Patient'
            />
          </div>
        </div>
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        {/* RECENT FROM BLOG */}
        <div>
          <h1 className='uppercase text-center mb-20 text-2xl sm:text-3xl text-gray-700'>
            RECENT FROM BLOG
          </h1>
          <div className='grid grid-cols-1 sm:grid-cols-2 gap-8'>
            <Blogs
              date='August 12, 2023 Admin'
              title='New technology facilities'
              description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
              pic={require("../../assets/blog/1.jpg")}
            />
            <Blogs
              date='August 12, 2023 Admin'
              title='New technology facilities'
              description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
              pic={require("../../assets/blog/2.jpg")}
            />
            <Blogs
              date='August 12, 2023 Admin'
              title='New technology facilities'
              description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
              pic={require("../../assets/blog/3.jpg")}
              direction={true}
            />
            <Blogs
              date='August 12, 2023 Admin'
              title='New technology facilities'
              description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
              pic={require("../../assets/blog/4.jpg")}
              direction={true}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
